import { queryOptions, useQuery, useSuspenseQuery } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { activitiesApi } from "../api/activities.api";
import { activityKeys } from "../constants/query-keys";

/** Every city with its counts (`/cities/explore`). */
export function citiesQueryOptions(lang: string) {
  return queryOptions({
    queryKey: [...activityKeys.cities(), lang],
    queryFn: () => activitiesApi.listCities(lang),
  });
}

export function useCities() {
  const { i18n } = useTranslation();
  return useSuspenseQuery(citiesQueryOptions(i18n.language));
}

/**
 * The same city list, without suspending.
 *
 * `useCities` is fine inside a boundary that already exists for it. A page
 * that only wants the city artwork to decorate a row it is already rendering
 * should not put its whole body behind a fallback while that arrives, so this
 * variant returns undefined until it lands and the caller falls back.
 */
export function useCitiesOptional() {
  const { i18n } = useTranslation();
  const lang = i18n.language;
  return useQuery(citiesQueryOptions(lang));
}
